import { isAdmin } from '@Common/Utils/Permissions'

const AdministrationPermissions = {
  read: isAdmin,
}

export default AdministrationPermissions
